// frontend-web/src/pages/Admin/AdminMegaQuizPreview.jsx
import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import api from "../../api";

export default function AdminMegaQuizPreview() {
  const { examId } = useParams();
  const nav = useNavigate();

  const [questions, setQuestions] = useState([]);
  const [answers, setAnswers] = useState({});
  const [loading, setLoading] = useState(true);
  const [timeLeft, setTimeLeft] = useState(0);

  useEffect(() => {
    loadQuiz();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [examId]);

  const loadQuiz = async () => {
    try {
      setLoading(true);
      const res = await api.get(`/admin/mega_scholarship/${examId}/start`);
      setQuestions(res.data.questions || []);
      setTimeLeft(res.data.duration_seconds || 0);
    } catch (err) {
      console.error(err);
      alert("Failed to load preview");
      nav("/admin/mega-scholarship-list");
    } finally {
      setLoading(false);
    }
  };

  // Timer
  useEffect(() => {
    if (timeLeft > 0) {
      const t = setTimeout(() => setTimeLeft((s) => s - 1), 1000);
      return () => clearTimeout(t);
    } else if (timeLeft === 0 && questions.length > 0) {
      submitQuiz();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [timeLeft, questions]);

  const handleAnswer = (qid, option) => {
    setAnswers(prev => ({ ...prev, [qid]: option }));
  };

  const submitQuiz = async () => {
    const answerList = questions.map(q => ({
      question_id: q.id,
      selected: answers[q.id] || null
    }));

    try {
      const res = await api.post(`/admin/mega_scholarship/${examId}/submit`, { answers: answerList });
      alert(`Score: ${res.data.score} / ${res.data.total}`);
      // optionally show details somewhere; for now navigate back
      nav("/admin/mega-scholarship-list");
    } catch (err) {
      console.error(err);
      alert("Submit failed");
    }
  };

  if (loading) return <div style={{ padding: 40 }}>Loading Preview...</div>;

  return (
    <div style={{ padding: 40 }}>
      <h1>Preview Quiz (Admin)</h1>
      <p>Time Left: {Math.floor(timeLeft / 60)}:{String(timeLeft % 60).padStart(2, "0")}</p>

      {questions.map(q => (
        <div key={q.id} style={{ marginBottom: 18, padding: 14, border: "1px solid #e5e7eb", borderRadius: 8 }}>
          <h3 style={{ margin: "0 0 8px" }}>{q.text}</h3>

          <label style={{ display: "block", marginBottom: 6 }}>
            <input
              type="radio"
              name={`q-${q.id}`}
              checked={answers[q.id] === "A"}
              onChange={() => handleAnswer(q.id, "A")}
            />{" "}
            A: {q.option_a}
          </label>

          <label style={{ display: "block", marginBottom: 6 }}>
            <input
              type="radio"
              name={`q-${q.id}`}
              checked={answers[q.id] === "B"}
              onChange={() => handleAnswer(q.id, "B")}
            />{" "}
            B: {q.option_b}
          </label>

          <label style={{ display: "block", marginBottom: 6 }}>
            <input
              type="radio"
              name={`q-${q.id}`}
              checked={answers[q.id] === "C"}
              onChange={() => handleAnswer(q.id, "C")}
            />{" "}
            C: {q.option_c}
          </label>

          <label style={{ display: "block", marginBottom: 6 }}>
            <input
              type="radio"
              name={`q-${q.id}`}
              checked={answers[q.id] === "D"}
              onChange={() => handleAnswer(q.id, "D")}
            />{" "}
            D: {q.option_d}
          </label>
        </div>
      ))}

      <div style={{ marginTop: 20 }}>
        <button onClick={submitQuiz} style={{ padding: "12px 24px", background: "#f59e0b", color: "white", borderRadius: 8 }}>
          Submit Quiz
        </button>
      </div>
    </div>
  );
}
